<template>
  <div class="intergration-drawer-wrapper mx-5">
    <div class="mt-2 d-flex justify-space-between">
      <div class="d-flex">
        <v-img
          :max-width="60"
          contain
          class="mx-3"
          :alt="heading"
          :src="logo"
        />
        <h2 style="line-height:85px;" class="mr-3">
          {{ heading }}
        </h2>
      </div>
      <v-col cols="1">
        <v-btn
          class="text-right mt-3"
          icon
          @click.stop="$store.commit('ui/drawer.right.toggle')"
        >
          <v-icon style="background-color:transparent" medium>
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <slot name="successMessage" />
    <div class="integration-drawer-heading mx-3 ">
      <h2>{{ subHeading }}</h2>

      <p class="my-4">
        {{ subHeadingPara }}
        <a :href="docsLink" target="_blank">
          {{ docsText }}
        </a>
      </p>

      <div class="integration-drawer-subheading mr-5" v-if="showCaption">
        <div class="py-3 px-3 bg-grey mr-2">
          <span class="font-weight-light">{{ captionTitle }}</span>
          <p class="drawer-paragraph-wrapper">
            {{ captionPara }}
            <a :href="docsLink" target="_blank"> 
              {{ docsText }}
            </a>
          </p>
        </div>
      </div>
    </div>
    <!-- Render integration form element here -->
    <slot name="form" />
  </div>
</template>

<script>
/**
 * Integrations drawer wrappercaptionPara
 * @author {Jatin Kamboj}
 */
export default {
  name: "IntergrationDrawerWrapper",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    logo: { type: String, default: "" },
    heading: { type: String, required: true, default: "" },
    showCaption: { type: Boolean, default: false },
    captionTitle: { type: String, required: true, default: "" },
    subHeading: { type: String, required: true, default: "" },
    captionPara: { type: String, default: "" },
    subHeadingPara: { type: String, required: true, default: "" },
    docsLink: { type: String, required: true, default: "" },
    docsText: { type: String, required: true, default: "" }
  }
};
</script>
